import dayjs from 'dayjs';
import {
    setActComplete,
    setAdvisor,
    setCity,
    setDateFromEditAppointment,
    setHideContactInfoFlag,
    setMobileServiceAddressAndPhoneNumber,
    setOssGlobalEdit,
    setPickupAddress,
    setPostalCode,
    setPrefillEdit,
    setRegionCode,
    setStreet,
    setTransportation,
    addAdditionalComments,
    setMyRewardsPointsIndicator,
} from './ActionCreator';
import { setupDateLocalization } from '../shared/Utils/TimeLocalization';
import store from './Store';
import { MOBILE_SERVICE, PICK_UP } from '../components/Appointment/AppointmentConstants';

const customParseFormat = require('dayjs/plugin/customParseFormat');
const sharedConstants = require('../shared/Constants/SharedConstants');

dayjs.extend(customParseFormat);

export default function editAppointmentHelper(data) {
    const transportationOption = getTransportationObject(data.transportationOption);

    store.dispatch(setMyRewardsPointsIndicator(data.useMyRewardsIndicator));
    store.dispatch(setPrefillEdit(data));
    store.dispatch(setOssGlobalEdit(data));
    store.dispatch(setTransportation(transportationOption));
    store.dispatch(addAdditionalComments(data.customerComments));
    store.dispatch(setHideContactInfoFlag('true'));

    prefillAddressFromEditAppointment(data);

    if (data.advisor) {
        store.dispatch(setAdvisor(data.advisor));
    }

    setupDateLocalization();

    const date = dayjs(data.appointmentDate + data.appointmentTime.start, 'YYYY-MM-DDHH:mm:ss');

    store.dispatch(setDateFromEditAppointment(date));

    // Once all the below async threads have spawned then set the flag to true
    store.dispatch(setActComplete(sharedConstants.EDTCOM));
}

function getTransportationObject(code) {
    const localStore = store.getState();
    let transportationOption = null;

    const { transportationOptions } = localStore.appointmentReducer;

    transportationOptions.forEach((option) => {
        if (option.code === code) {
            transportationOption = option;
        }
    });

    return transportationOption;
}

function selectServiceAddress(data) {
    if (!data.serviceAddresses || data.serviceAddresses.length === 0) {
        return null;
    }

    const pickUpAddress = data.serviceAddresses.find((serviceAddress) => serviceAddress.type === PICK_UP);

    return pickUpAddress || data.serviceAddresses[0];
}

function prefillAddressFromEditAppointment(data) {
    const address = selectServiceAddress(data) || (data.customer && data.customer.address);

    if (!address) {
        return;
    }

    const country = address.countrySubentityCode ? address.countrySubentityCode.split('-')[0] : '';

    store.dispatch(setStreet(address.addressLine1 || ''));
    store.dispatch(setCity(address.cityName || ''));
    store.dispatch(setRegionCode(address.countrySubentity || ''));
    store.dispatch(setPostalCode(address.postalZone || ''));

    if (data.transportationOption === MOBILE_SERVICE) {
        const pickupAddress = [
            address.addressLine1,
            address.cityName,
            address.countrySubentity,
            address.postalZone,
            country,
        ]
            .filter(Boolean)
            .join(',');

        store.dispatch(setPickupAddress(pickupAddress));

        if (data.serviceAddresses && data.serviceAddresses.length > 0) {
            store.dispatch(
                setMobileServiceAddressAndPhoneNumber({
                    serviceAddresses: data.serviceAddresses,
                    serviceCommunications: data.serviceCommunications,
                })
            );
        }
    }
}
